
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10536_5181)","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.709 7.857v.934a.824.824 0 01-.824.824h-5.77a.824.824 0 01-.824-.824v-.934M2.94 5.027L5 7.087l2.06-2.06M5 7.143V.714"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10536_5181"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(90 5 5)","d":"M0 0h10v10H0z"}})])])])
          )
        }
      }
    